


jQuery('.prevent-default').click(function() {
    return false;
});
jQuery('.prevent-default a[href="#"]').click(function() {
    return false;
});

jQuery(document).ready(function() {
    $('.four-lines .post-excerpt').ellipsis({ lines: 4 });
    //jQuery('.slide-info').ellipsis({ lines: 5 });
});

var controls = document.getElementById("controls");
var dotsWrapper = document.getElementById("dots-nav-wrapper");
jQuery(document).ready(function($) {
    $('.top-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        dots: true,
        speed: 5000,
        autoplay: true,
        appendDots: dotsWrapper,
        waitForAnimate: true,
        useTransform: true,
        cssEase: 'cubic-bezier(0.455, 0.030, 0.130, 1.000)',
    }).slickAnimation();
    /*

   // On before slide change match active thumbnail to current slide
   $('.top-slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    var mySlideNumber = nextSlide;
  });

//UPDATED 
  
  $('.top-slider').on('afterChange', function(event, slick, currentSlide){   
  $('.content').hide().removeClass( "current" );
  $('.content[data-id=' + (currentSlide + 1) + ']').show().addClass( "current" );
  });
  */
});

$('#scrollToContent').on('click', function(){
    $('html, body').animate({
        scrollTop: $('main').offset().top
    }, 500);
});










$(document).ready(function(){
  $("#main-nav .dropdown").hover(function(){
    var dropdownMenu = $(this).children(".dropdown-menu");
    if(dropdownMenu.is(":visible")){
      dropdownMenu.parent().toggleClass("show");
    }
  });
});

$(document).ready(function(){
    $('#main-nav .dropdown').hover(function() {
      $(this).find('.dropdown-menu').first().stop(true, true).delay(0);
      $(this).addClass( "show" );
    }, function() {
      $(this).find('#main-nav .dropdown-menu').first().stop(true, true).delay(0);
      $(this).removeClass( "show" );
    });
    /*
    $('#main-nav .dropdown > a').click(function(){
        location.href = this.href;
    });
    */
});



jQuery(document).ready(function($) {
    var $slider = $('.poster-slider');
    $slider.slick({
        dots: true,
        infinite: true,
        arrows: false,
        speed: 800,
        autoplay: true,
        lazyLoad: 'progressive',
        slidesToShow: 1,
        slidesToScroll: 1,
        waitForAnimate: true,
        useTransform: true,
        cssEase: 'cubic-bezier(0.455, 0.030, 0.130, 1.000)',
    }).slickAnimation();
})



/*

$('.featured-merch').slick({
    dots: false,
    infinite: true,
    arrows: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [{
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                dots: true
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
});


$('.featured-instagram').slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    centerMode: true,
    responsive: [{
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                dots: true
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        }
    ]
});


*/

$('.distillery-spaces-slider').slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: false,
});


$('.img-slider').slick({
    dots: true,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
});




$('.cocktail-slides').on('setPosition', function(e, sl){
  sl.$slideTrack.css('width', 100000);
}).slick({
    centerMode: false,
    dots: false,
    arrows: false,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [{
            breakpoint: 992,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                centerMode: true,
                slidesToScroll: 1,
                infinite: true
            }
        }
    ]
});



/*
$(document).ready(function() {
    var thing1 = $('.num1'),
        thing2 = $('.num2'),
        thing3 = $('.num3'),
        row = $('.row'),
        pageHeight = $(window).height();
    $(thing1).addClass('offscreen');
    $(window).scroll(function() {
        var scrollDistance = $(this).scrollTop();
        $.each(row, function() {
            var rowScroll = $(this).offset().top - pageHeight * .7;
            if (scrollDistance > rowScroll) {
                $(this).children('.col').removeClass('offscreen');
            } else {
                $(this).children('.col').addClass('offscreen');
            };
        });
    });
});
*/

$('.dropdown-container #mobile-nav').each(function() {
  var self = $(this)

  var label = $('> a .dropmenu-item-label', this) ? $('> a .dropmenu-item-label', this).text() : $('> a', this).text()
  var backlink = $('<li class="dropdown-backlink"><a href="#">' + label + '</a></li>')

  $(this).find('ul').first().prepend(backlink)

  // Attach listeners to the back buttons
  $(this).find('> ul > li').on('click', function(e){
      e.preventDefault()
      e.stopPropagation()

      var self = $(this)
      var container = self.closest('.dropdown-submenu')
      var parentDropdown = container.closest('.dropdown-menu')

      if (!self.hasClass('dropdown-backlink')) {
        container.find('> a .dropmenu-item-content').text(self.text())
      }

      self.closest('.dropdown-container').css({
        'width': parentDropdown.outerWidth(),
        'height': parentDropdown.outerHeight()
      })

      container.removeClass('open')
   })

})
$(function() {
  $('#mobile-menu').on('hide.bs.collapse', function () {
    $('.navbar-toggler').removeClass('open');
  })
  $('#mobile-menu').on('show.bs.collapse', function () {
    $('.navbar-toggler').addClass('open');
  })
});



jQuery(function($) {
  $( "#filterBySpirit li" ).click(function() {
    $('#filterBySpirit').collapse('hide');
  });
}); 

jQuery(function($) {
  $( ".filterByState li" ).click(function() {
    $('.filterByState').collapse('hide');
  });
}); 
/*
jQuery(function($) {
    $(".ageVinput").keyup(function () {
        if (this.value.length == this.maxLength) {
          var $next = $(this).next('.ageVinput');
          if ($next.length)
              $(this).next('.ageVinput').focus();
          else
              $(this).blur();
        }
    });
});
*/

var container = document.getElementsByClassName("ageInputsV")[0];
container.onkeyup = function(e) {
    var target = e.srcElement;
    var maxLength = parseInt(target.attributes["maxlength"].value, 10);
    var myLength = target.value.length;
    if (myLength >= maxLength) {
        var next = target;
        while (next = next.nextElementSibling) {
            if (next == null)
                break;
            if (next.tagName.toLowerCase() == "input") {
                next.focus();
                break;
            }
        }
    }
}

/*
function setInputFilter(textbox, inputFilter) {
  ["input", "keydown", "keyup", "mousedown", "mouseup", "select", "contextmenu", "drop"].forEach(function(event) {
    textbox.addEventListener(event, function() {
      if (inputFilter(this.value)) {
        this.oldValue = this.value;
        this.oldSelectionStart = this.selectionStart;
        this.oldSelectionEnd = this.selectionEnd;
      } else if (this.hasOwnProperty("oldValue")) {
        this.value = this.oldValue;
        this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
      } else {
        this.value = "";
      }
    });
  });
}

setInputFilter(document.getElementById("dob-month"), function(value) {
  return /^-?\d*$/.test(value); });
setInputFilter(document.getElementById("dob-day"), function(value) {
  return /^-?\d*$/.test(value); });
setInputFilter(document.getElementById("dob-year"), function(value) {
  return /^-?\d*$/.test(value); });
*/

